// Tytuły importowanych publikacji bywają zapisane w całości wersalikami.
// Normalizujemy je do zapisu zdaniowego tylko w warstwie wyświetlania —
// dane źródłowe zostają nietknięte.

const MIN_LENGTH = 16

// Skróty, które po zrzuceniu do małych liter muszą wrócić do wersalików.
const ABBREVIATIONS = new Set([
  'AI',
  'CIT',
  'CJEU',
  'DOI',
  'ECHR',
  'ETPC',
  'ETS',
  'EU',
  'GUS',
  'ISBN',
  'ISSN',
  'KC',
  'KK',
  'KPA',
  'KPC',
  'KRS',
  'NATO',
  'NSA',
  'OECD',
  'ONZ',
  'PDF',
  'PIT',
  'PKB',
  'PKD',
  'RODO',
  'RP',
  'SN',
  'TK',
  'TSUE',
  'UE',
  'UK',
  'USA',
  'VAT',
  'WSA',
  'WTO',
  'ZUS',
])

// Tylko jednoznaczne liczebniki — pojedyncze litery (I, V, X, L, C, D, M)
// i zbitki typu „MI", „CI" pomijamy, bo w polskim są zwykłymi wyrazami.
const ROMAN_NUMERALS = new Set([
  'II',
  'III',
  'IV',
  'VI',
  'VII',
  'VIII',
  'IX',
  'XI',
  'XII',
  'XIII',
  'XIV',
  'XV',
  'XVI',
  'XVII',
  'XVIII',
  'XIX',
  'XX',
  'XXI',
  'XXII',
  'XXIII',
  'XXIV',
  'XXV',
])

const TOKEN_SEPARATOR = /([^\p{L}\p{N}\-'’]+)/u
const HAS_DIGIT = /\p{N}/u
const HAS_LETTER = /\p{L}/u

const isAllUppercase = (value) => {
  const uppercase = value.toLocaleUpperCase()

  return value === uppercase && uppercase !== value.toLocaleLowerCase()
}

const capitalizeFirstLetter = (value) => value.replace(/\p{L}/u, (letter) => letter.toLocaleUpperCase())

const normalizeToken = (token) => {
  const uppercaseToken = token.toLocaleUpperCase()

  if (ABBREVIATIONS.has(uppercaseToken) || ROMAN_NUMERALS.has(uppercaseToken)) {
    return uppercaseToken
  }

  // „COVID-19", „ART. 15" — mieszanki z cyframi zostawiamy jak w oryginale.
  if (HAS_DIGIT.test(token) && HAS_LETTER.test(token)) {
    return token
  }

  return token.toLocaleLowerCase()
}

export const formatDisplayTitle = (title) => {
  if (typeof title !== 'string') {
    return title
  }

  const trimmedTitle = title.trim()

  if (trimmedTitle.length < MIN_LENGTH || !isAllUppercase(trimmedTitle)) {
    return title
  }

  const normalized = title
    .split(TOKEN_SEPARATOR)
    .map((token) => (TOKEN_SEPARATOR.test(token) ? token : normalizeToken(token)))
    .join('')

  // Wielka litera na początku oraz po kropce, dwukropku, znaku zapytania i wykrzykniku.
  return capitalizeFirstLetter(normalized).replace(
    /([.!?:]\s+)(\p{Ll})/gu,
    (match, separator, letter) => `${separator}${letter.toLocaleUpperCase()}`,
  )
}
